var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      (_vm.is_responsive != true && !_vm.isMobile) || _vm.is_responsive == true
        ? _c(
            "carousel",
            {
              attrs: {
                autoplay: false,
                loop: false,
                items: _vm.items,
                autoplayHoverPause: true,
                margin: 24,
                responsive: _vm.is_responsive == true ? _vm.reponsive : false,
                navText: _vm.navText,
              },
            },
            [_vm._t("slides")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.is_responsive != true && _vm.isMobile
        ? _c("div", [_vm._t("slides")], 2)
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }